var _tspan;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3795 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "square",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard3",
    x: 0,
    y: 0,
    width: 3794.68,
    height: 600,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3594.92,440.813c0,13.331 4.387,23.793 13.162,31.386c8.943,7.593 20.923,11.474 36.279,11.474c15.692,0 28.01,-3.712 36.616,-11.137c8.606,-7.256 12.824,-17.886 12.824,-31.554c0,-8.437 -1.518,-17.886 -4.556,-28.686l12.318,0c3.038,8.269 4.725,18.562 4.725,30.88c0,17.717 -5.4,31.385 -16.199,41.003c-10.799,9.618 -25.986,14.512 -45.897,14.512c-12.318,-0 -23.286,-2.363 -32.567,-6.919c-9.449,-4.724 -16.536,-11.474 -21.598,-20.079c-5.063,-8.775 -7.594,-19.068 -7.594,-31.048c0,-12.656 2.363,-23.624 6.919,-33.073l11.98,5.906c-4.218,9.112 -6.412,18.223 -6.412,27.335Z",
    style: {
      fill: "#ff0cbf",
      fillRule: "nonzero",
      stroke: "#ff0dbf",
      strokeWidth: "10.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3704.61,385.997l-120.48,-0l-0,-14.005l107.824,-0l0,-53.153l12.656,-0l-0,67.158Z",
    style: {
      fill: "#ff0cbf",
      fillRule: "nonzero",
      stroke: "#ff0dbf",
      strokeWidth: "10.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3584.12,209.112l77.957,-0c13.668,-0 24.468,4.049 32.398,12.486c7.762,8.269 11.812,19.574 11.812,34.086c0,14.511 -4.05,25.817 -11.98,33.747c-7.762,7.931 -18.731,11.812 -32.567,11.812l-77.62,0l-0,-14.005l78.632,-0c10.125,-0 17.718,-2.7 23.118,-8.268c5.399,-5.4 8.099,-13.5 8.099,-24.13c0,-10.124 -2.7,-18.055 -8.099,-23.455c-5.4,-5.568 -13.162,-8.268 -23.286,-8.268l-78.464,0l-0,-14.005Z",
    style: {
      fill: "#ff0cbf",
      fillRule: "nonzero",
      stroke: "#ff0dbf",
      strokeWidth: "10.12px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3584.12,177.216l-0,-34.085c-0,-16.031 2.362,-27.505 7.256,-34.592c4.724,-7.256 12.318,-10.799 22.611,-10.799c7.087,-0 12.993,2.025 17.717,6.074c4.556,3.881 7.594,9.787 8.943,17.381l0.844,-0c3.206,-18.393 12.656,-27.505 28.855,-27.505c10.799,0 19.067,3.712 25.142,10.968c6.074,7.256 9.112,17.38 9.112,30.542l-0,42.016l-120.48,-0Zm51.634,-14.005l0,-23.118c0,-9.787 -1.519,-17.042 -4.725,-21.261c-3.037,-4.387 -8.268,-6.581 -15.692,-6.581c-6.75,0 -11.643,2.363 -14.512,7.256c-3.037,4.894 -4.556,12.487 -4.556,23.117l0,20.587l39.485,-0Zm11.812,-0l45.053,-0l0,-25.143c0,-9.786 -1.856,-17.042 -5.568,-21.936c-3.881,-4.893 -9.618,-7.424 -17.718,-7.424c-7.424,-0 -12.993,2.531 -16.536,7.593c-3.375,5.062 -5.231,12.656 -5.231,22.949l-0,23.961Z",
    style: {
      fill: "#ff0cbf",
      fillRule: "nonzero",
      stroke: "#ff0dbf",
      strokeWidth: "10.12px"
    }
  })), /*#__PURE__*/React.createElement("text", {
    x: "487.988px",
    y: "500.021px",
    style: {
      fontFamily: "'ArialRoundedMTBold', 'Arial Rounded MT Bold', sans-serif",
      fontSize: "549.5px"
    }
  }, "SONRISAS", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "3381.72px ",
    y: "500.021px "
  }, "."))), /*#__PURE__*/React.createElement("path", {
    d: "M165.391,300.541c0,-0 16.305,9.789 35.497,21.311c40.68,24.428 91.132,25.96 133.221,4.039c27.03,-14.016 54.74,-30.879 69.395,-47.397c0.006,0.006 0.053,-0.003 0.134,-0.025c7.246,-1.087 14.382,2.544 17.767,9.04c3.388,6.496 2.276,14.424 -2.764,19.74c0.344,0.61 0.265,0.688 0.248,0.688c-14.141,26.052 -23.55,63.039 -21.585,105.2c0,26.15 -11.435,49.007 -30.72,61.253c-18.675,11.861 -42.949,9.907 -59.486,-4.791c-5.669,-5.042 -11.704,-10.404 -17.451,-15.514c-15.771,-14.018 -39.548,-13.987 -55.282,0.073c-5.644,5.046 -11.567,10.34 -17.152,15.329c-16.607,14.843 -41.057,16.839 -59.85,4.884c0.003,-0.003 0,-0.006 0,-0.006c-19.259,-12.252 -30.681,-35.095 -30.681,-61.228c5.199,-46.468 -4.408,-88.216 -29.767,-117.927c-14.82,-19.721 -23.603,-44.219 -23.603,-70.754c-0,-31.092 12.056,-59.386 31.746,-80.465l0.003,-0c28.363,-30.362 74.508,-35.799 109.15,-12.856c5.663,3.59 11.293,7.106 16.62,10.466c18.785,12.881 43.548,12.914 62.371,0.089c5.58,-3.491 11.486,-7.139 17.451,-10.792c34.38,-22.544 79.976,-17.177 108.183,12.73l0.053,-0.048c3.168,3.357 6.989,8.056 10.922,13.197c15.469,18.638 18.502,44.64 7.737,66.34l0.101,0.05",
    style: {
      fill: "none",
      stroke: "url(#_Linear1)",
      strokeWidth: "48.39px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(370.618,0,0,365.157,73.3117,299.565)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#a524b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ff0dbf",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.f1a18263932fe7b0ccfdb636277d72d9.svg";
export { ForwardRef as ReactComponent };